import { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { YatPageVersion } from '@app/client';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

/**
 * This hook checks for any public path redirects that don't include
 * returning to sign in
 *
 * Currently only EmojiId edit
 *
 */

const EDIT_PATHS = ['edit', 'editlinks'];
const V2_EDIT_PATH = '/profile/edit';
export function useCheckPublicRedirects() {
    const { pathname } = useLocation();
    const { yatParam } = useParams();

    const { isAuthenticated } = useAuthTokens();
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const yatPageVersion = useAppSelector((state) => state.yatPage.yatPageVersion);
    const editInPath = !!EDIT_PATHS.find((path) => pathname.includes(path));
    const cannotEdit = !isAuthenticated || !isPageOwner;

    const [redirectTo, setRedirectTo] = useState<string>();

    useEffect(() => {
        if (!yatPageVersion || !editInPath) return;

        if (cannotEdit) {
            setRedirectTo(`/${yatParam}`);
        }

        if (!cannotEdit && yatPageVersion !== YatPageVersion.V1) {
            setRedirectTo(V2_EDIT_PATH);
        }
    }, [cannotEdit, editInPath, yatPageVersion, yatParam]);

    return { redirectTo };
}
